module.exports = __webpack_public_path__ + "static/img/case2.1600a61c.jpg";